module.exports = __webpack_public_path__ + "img/mail.9276b29c.png";